export function getPortraitPlaneAspect(sourceAspectRatio, options = {}) {
  const aspect = toFiniteNumber(sourceAspectRatio, 1);
  const hasMinAspect = Number.isFinite(Number(options.minAspect));
  const hasMaxAspect = Number.isFinite(Number(options.maxAspect));

  if (!hasMinAspect && !hasMaxAspect) {
    return round(aspect);
  }

  const minAspect = hasMinAspect ? Number(options.minAspect) : 0;
  const maxAspect = hasMaxAspect
    ? Math.max(minAspect, Number(options.maxAspect))
    : Infinity;

  return round(Math.min(maxAspect, Math.max(minAspect, aspect)));
}

function toFiniteNumber(value, fallback) {
  const number = Number(value);

  return Number.isFinite(number) ? number : fallback;
}

function round(value) {
  return Math.round(value * 10000) / 10000;
}
